import { API_ENDPOINTS } from "@utils/api/endpoints";
import { useEnumStore } from '@stores/enum';

export default async function (force = false) {
  const enums = useEnumStore();
  const routeLang = useRouteLang();

  if (!enums?.catalogueParameters?.length || force) {
    const { data, error, status } = await useApiFetch(API_ENDPOINTS.CATALOGUE_PARAMETER, {
      key: `catalogue-parameters-${routeLang.locale.value}`,
      params: {
        locale: routeLang.locale.value
      }
    });

    if (status.value === 'error') {
      sentryCaptureEvent({
        message: 'load-catalogue-parameters',
        level: 'error',
        extra: { error: error.value }
      });
    } else {
      enums.setCatalogueParameters(data.value || []);
    }
  }
}
